module.exports = __webpack_public_path__ + "static/media/piper-thumb2.b666fe32.svg";